import { useQuery } from "@tanstack/react-query";
import { rmListApi } from "components/api/comm";
import Select, { SelectProps } from "components/select";
import { ISelect } from "interface";
import { IRm } from "interface/rm/rm";
import i18n from "locales/i18n";
import { useRef } from "react";
import useLodStore from "store/lod";

interface IProps extends Omit<SelectProps, "options"> {
  isFullInf?: boolean;
  select?(inf: any): void;
}

export default function RmNmSelect({
  defaultValue,
  isReset,
  required,
  isFullInf = false,
  select,
}: IProps) {
  const langCd = i18n.language;
  const lod = useLodStore((state) => state.lod);
  const lodNo = lod?.lodNo ?? "";
  const rmsRef = useRef<ISelect[]>([]);
  useQuery({
    queryKey: ["rmList"],
    queryFn: () => {
      return rmListApi({ langCd: langCd, lodNo });
    },
    select: (data) => {
      if (data) {
        rmsRef.current = data.data.rmList
          .filter((rm: IRm) => {
            return !!rm.rmNm;
          })
          .map((rm: IRm) => {
            return {
              ko: langCd === "ko" ? rm.rmNm : "",
              en: langCd === "en" ? rm.rmNm : "",
              value: rm.rmNo,
              code: rm.rmNo,
              ...rm,
            };
          });
      }
    },
    enabled: !!lodNo,
  });

  return (
    <>
      <Select
        options={rmsRef.current}
        defaultValue={defaultValue}
        dataTyp={"C"}
        name={"rmNo"}
        required={required}
        isReset={isReset}
        validateTxt="객실을 선택하여 주세요."
        onSelect={(option) => {
          if (select) {
            isFullInf ? select(option) : select(option?.rmNo);
          }
        }}
      />
    </>
  );
}
